export default __webpack_public_path__ + "static/media/step3bLightMode.960f7af1.svg";